import { fileIcon } from './icons';

const ATTACHMENT_CLASS = 'flix-chat-widget__attachment';
export const ATTACHMENT_ICON_CLASS = `${ATTACHMENT_CLASS}-icon`;
export const ATTACHMENT_ERROR_CLASS = `${ATTACHMENT_CLASS}--error`;

export function formatFileSize(byteSize: number): string {
  if (byteSize < 1024) {
    return `${byteSize} B`;
  }

  const kilobytes = byteSize / 1024;

  if (kilobytes < 1024) {
    return `${kilobytes.toFixed(1)} KB`;
  }

  const megabytes = kilobytes / 1024;

  return `${megabytes.toFixed(1)} MB`;
}

/**
 * Renders exactly one attachment card: icon tile, filename + size, nothing
 * else — no preview, no download link. Shared by the message list
 * (already-sent attachments) and the composer (pending uploads), which
 * appends its own status/retry/remove controls on top of this same element.
 *
 * icon defaults to the plain file glyph; message.ts's inline image loader
 * swaps in a spinner/warning icon for its own loading/error states while
 * reusing this exact same card shape, rather than building a second one.
 */
export function createAttachmentCardElement(
  filename: string,
  byteSize: number,
  icon: SVGSVGElement = fileIcon(),
): HTMLElement {
  const element = document.createElement('div');
  element.className = ATTACHMENT_CLASS;

  const iconTile = document.createElement('span');
  iconTile.className = ATTACHMENT_ICON_CLASS;
  iconTile.append(icon);

  const meta = document.createElement('div');
  meta.className = `${ATTACHMENT_CLASS}-meta`;

  const name = document.createElement('span');
  name.className = `${ATTACHMENT_CLASS}-name`;
  name.textContent = filename;

  const size = document.createElement('span');
  size.className = `${ATTACHMENT_CLASS}-size`;
  size.textContent = formatFileSize(byteSize);

  meta.append(name, size);
  element.append(iconTile, meta);

  return element;
}
